import { type ReactNode } from 'react';
import styles from './FieldBlock.scss';

interface FieldBlockProps {
  label: string;
  children: ReactNode;
}

export const FieldBlock = ({ label, children }: FieldBlockProps) => (
  <div className={styles.fieldBlock}>
    <p className={styles.fieldLabel}>{label}</p>
    {children}
  </div>
);
